// src/components/AvatarPicker.js
import React, { useState, useEffect } from "react";
import "./AvatarPicker.css";
import countries from "./countries"; // your JS array of countries

const avatars = [
  {
    id: 1,
    name: "Talib",
    image: "/avatars/talib.png",
    description: "The Male Learner – eager to gain knowledge and wisdom.",
  },
  {
    id: 2,
    name: "Talibah",
    image: "/avatars/talibah.png",
    description: "The Female Learner – passionate about learning and growth.",
  },
];

function AvatarPicker({ onSelect }) {
  const [selectedAvatar, setSelectedAvatar] = useState(() => {
    try {
      return localStorage.getItem("avatar") || "";
    } catch {
      return "";
    }
  });
  const [selectedCountry, setSelectedCountry] = useState(() => {
    try {
      return localStorage.getItem("country") || "";
    } catch {
      return "";
    }
  });
  const [userName, setUserName] = useState(() => {
    try {
      return localStorage.getItem("userName") || "";
    } catch {
      return "";
    }
  });

  useEffect(() => {
    if (selectedAvatar) {
      try {
        localStorage.setItem("avatar", selectedAvatar);
        localStorage.setItem("country", selectedCountry);
        localStorage.setItem("userName", userName);
      } catch (error) {
        console.warn("localStorage not available:", error);
      }
      onSelect({
        avatar: selectedAvatar,
        country: selectedCountry,
        name: userName,
      });
    }
  }, [selectedAvatar, selectedCountry, userName, onSelect]);

  return (
    <div className="avatar-picker">
      <h2>Select Your Avatar</h2>

      <div className="avatar-grid">
        {avatars.map((avatar) => (
          <div
            key={avatar.id}
            className={`avatar-card ${
              selectedAvatar === avatar.image ? "selected" : ""
            }`}
            onClick={() => setSelectedAvatar(avatar.image)}
          >
            <div className="avatar-image-wrapper">
              <img
                src={avatar.image}
                alt={avatar.name}
                className="avatar-image"
              />
            </div>
            <p>{avatar.name}</p>
            <span className="avatar-description">{avatar.description}</span>
          </div>
        ))}
      </div>

      <div className="input-section">
        <label htmlFor="user-name">Enter Your Name:</label>
        <input
          id="user-name"
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Your name here"
        />
      </div>

      <div className="country-selector">
        <label htmlFor="country-select">Select Your Country: </label>
        <select
          id="country-select"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
        >
          <option value="">-- Choose --</option>
          {countries.map((c) => (
            <option key={c.code} value={c.code}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default AvatarPicker;
